import { GzSliderWebComponent } from './component/GzSliderWebComponent';
import { WEB_COMPONENT_GZ_SLIDER } from '../../webcomponents.constants';

export { GzSliderWebComponent };

window.customElements.define(WEB_COMPONENT_GZ_SLIDER, GzSliderWebComponent);
